import x from "@/assets/images/x.png"
import done from "@/assets/images/done.png"
import tg from "@/assets/images/tg.png"
import text from "@/assets/images/text.png"

const Footer = () => {
    const linkList =
        [
            {
                link: 'https://t.me/TheStarAIBot',
                image: tg
            },
            {
                link: 'https://x.com/the_starai',
                image: x
            },
            {
                link: 'https://telegram.org/privacy-tpa',
                image: done
            },
            {
                link: 'https://telegram.org/tos/mini-apps',
                image: text
            },
        ]

    return (
        <div className="max-xg:hidden w-[319px] h-[20px] flex items-center gap-[10px] bottom-5 right-[100px] max-md:hidden fixed ">
            {linkList.map((el: any) => (
                <a key={el.link} target="_blank" className=" cursor-pointer" href={el.link}>
                    <img className="h-5" src={el.image} alt="" />
                </a>))}
            <p className=" text-[14px] text-[#fff] font-semibold leading-[18px]">© 2024 StarAl . All rights reserved.</p>
        </div>
    )
}


export default Footer